import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  cacheSize: 100,
  extend: {
    classGroups: {
      shadow: [{ shadow: ["soft"] }],
      "font-size": [{ text: ["tiny", "tiny+", "xs+", "sm+", "md"] }],
    },
  },
});

export default twMerge;
